import {UpdateDraftParkNote, DeleteDraftParkNote} from '@/graphql/mutations/ParkNote.graphql'
import {GetDraftParkNote, GetDraftParkNoteFromParkId} from '@/graphql/queries/ParkNote.graphql'

import { Base64 } from 'js-base64'

export default {
  data(){
    return {
      isEnableDraftFunction   : false,
      saveDraftInterval       : null,
      autoSaveSecond          : 30,
      previousDraftString     : null,

      defaultTitle            : '',
      defaultBodyDeltaString  : '',
    };
  },

  apollo : {
    draftParkNoteFromParkId : {
      query: GetDraftParkNoteFromParkId,

      variables(){
        return {
          park_id  : this.parkId
        };
      },

      fetchPolicy: 'no-cache',

      skip(){
        if(this.isModalOpend === true){
          if(this.editorBehaviour === 'new'){
            return false;
          }else{
            return true;
          }
        }else{
          return true;
        }
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },
  },

  watch : {
    editorBehaviour : {
      handler(value){
        if(value === 'new'){
          this.isEnableDraftFunction = true;
        }else{
          this.isEnableDraftFunction = false;
        }
      },
      immediate: true
    },

    draftParkNoteFromParkId : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(data === null) return;

        if(data.title !== null && data.title !== ''){
          this.defaultTitle = data.title;
        }

        if(data.body !== null && data.body !== ''){
          this.defaultBodyDeltaString = data.body;
        }
      },
      deep: true
    }
  },

  methods : {
    executeDeleteDraftParkNote(payload){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : DeleteDraftParkNote,
          variables : {
            parkId      : payload.parkId
          }
        }).then(async ({data: {DeleteDraftParkNote:{status}}}) => {
          this.$apollo.queries.draftParkNoteFromParkId.refetch();
          
          resolve(status);
        }).catch(async (error) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(error);

          if(typeof simpleErrorSet.firstError.field !== 'undefined'){
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;'+simpleErrorSet.firstError.message,
              status      : 'error',
              hasControl  : true,
              autoClose   : 3000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    executeInsertDraftParkNote(payload){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UpdateDraftParkNote,
          variables : {
            parkId      : payload.parkId,
            title       : payload.title,
            body        : payload.body,
            text        : payload.text,
            textCounter : payload.textCounter
          },
          update    : (store, {data: {UpdateDraftParkNote}}) => {
            if(UpdateDraftParkNote !== null){
              console.log('saved draft park note.');
              store.writeQuery({
                query     : GetDraftParkNote,
                variables : {
                  id  : UpdateDraftParkNote.id
                },
                data      : {
                  draftParkNote : UpdateDraftParkNote
                }
              });
            }
          }
        }).then(async ({data: {UpdateDraftParkNote}}) => {
          this.$apollo.queries.draftParkNoteFromParkId.refetch();
          resolve(UpdateDraftParkNote);
        }).catch(async (error) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(error);

          if(typeof simpleErrorSet.firstError.field !== 'undefined'){
            const errorMessageTextSet = {
              'default'                               : "エラーが発生しました。",
              'Could not enough character ink body'   : "&nbsp;インクが足りません。",
              'This text include In-Acceptable wrod.' : "&nbsp;こちらの内容はご投稿いただくことができかねます。",
            };

            let errorMessageText = '';

            if(typeof errorMessageTextSet[simpleErrorSet.firstError.message] !== 'undefined'){
              errorMessageText = errorMessageTextSet[simpleErrorSet.firstError.message];
            }else{
              errorMessageText = errorMessageTextSet['default'];
            }

            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : errorMessageText,
              status      : 'error',
              hasControl  : true,
              autoClose   : 3000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    async saveDraftParkNote(){
      if(this.editorBehaviour !== 'new') return;

      let deltaStringifyData = null;
      let onlyTextData       = null;

      if(this.editorData !== null){
        if(typeof this.editorData.delta !== 'undefined'){
          deltaStringifyData = JSON.stringify(this.editorData.delta);
        }

        if(typeof this.editorData.onlyText !== 'undefined'){
          onlyTextData = this.editorData.onlyText;
        }
      }

      let titleAndDelta = this.titleData + deltaStringifyData;

      if( (this.titleData === '' || this.titleData === null ) && (deltaStringifyData === null || deltaStringifyData === '') ){
        return;
      }

      if(this.previousDraftString === titleAndDelta){
        console.log('draft data was not changed.');
        return;
      }

      if(this.titleData === '' && onlyTextData === ''){
        return;
      }

      let saveTitle = '';
      if(this.titleData.length > this.titleLimitationLength){
        saveTitle = this.titleData.substr(0, 16);
      }else{
        saveTitle = this.titleData;
      }

      await this.executeInsertDraftParkNote({
        parkId      : this.parkId,
        title       : saveTitle,
        body        : Base64.encode(deltaStringifyData),
        text        : onlyTextData,
        textCounter : 0,
      });

      this.previousDraftString = titleAndDelta;
    },

    async handleClickDeleteDraftData(){
      await this.executeDeleteDraftParkNote({
        parkId      : this.parkId
      });

      this.defaultTitle = null;
      this.defaultBodyDeltaString = null;
      this.previousDraftString = null;
    },

    startDraftInterval(){
      this.clearDraftInterval();

      this.saveDraftInterval = setInterval(() => {
        this.saveDraftParkNote();
      }, this.autoSaveSecond*1000);
    },

    clearDraftInterval(){
      if(this.saveDraftInterval !== null){
        clearInterval(this.saveDraftInterval);
        this.saveDraftInterval   = null;
        this.previousDraftString = null;
      }
    },
  },

  created(){
    this.startDraftInterval();
  },

  beforeDestroy(){
    clearInterval(this.saveDraftInterval);
  }
}